// Minimal IndexedDB wrapper to persist raw responses for auditing/recovery.

const DB_NAME = "rawResponsesDB";
const STORE = "responses";

function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE))
        db.createObjectStore(STORE, { keyPath: "id", autoIncrement: true });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function saveRawResponse(payload: {
  url: string;
  method: string;
  status: number;
  timestamp: number;
  raw: any;
}) {
  try {
    const db = await openDB();
    const tx = db.transaction(STORE, "readwrite");
    const store = tx.objectStore(STORE);
    store.add({ ...payload });
    // return tx.complete;
    return tx.oncomplete;
  } catch (e) {
    console.warn("IndexedDB not available, falling back to sessionStorage");
    try {
      const arr = JSON.parse(sessionStorage.getItem("rawResponses") || "[]");
      arr.push(payload);
      sessionStorage.setItem("rawResponses", JSON.stringify(arr.slice(-200))); // limit size
    } catch {
      console.warn("SessionStorage not available");
    }
  }
}
